import { isRumActive, recordRumPageView } from '@/rum';

import { useEffect } from 'react';

import { useLocation } from 'react-router';

import { normalizeRumPageId } from '@/utils/rumPageId';

/**
 * Records normalized SPA page views on route changes when RUM is enabled.
 */
export const RumPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isRumActive()) return;

    const pageId = normalizeRumPageId(location.pathname);
    recordRumPageView(pageId);
  }, [location.pathname]);

  return null;
};
